import { getModel, getModelName, getModelPropOrDefault, getTableSettingsIdentifier } from "~/stateGetter";

export class StateGetterBase {
    state = null;

    get modelName () {
        return getModelName(this.state, this.modelId)
    };

    get tableSettingsIdentifier () {
        return getTableSettingsIdentifier(this.state, this.modelId);
    };

    constructor(state, modelId) {
        this.state = state;
        this.modelId = modelId;
    }

    getModel() {
        return getModel(this.state, this.modelId);
    }

    getModelPropsOrFail(path) {
        return getModelPropOrFail(this.state, this.modelId, path);
    }

    getModelPropOrDefault(path, defaultValue) {
        return getModelPropOrDefault(this.state, this.modelId, path, defaultValue);
    }
}